module.exports = __webpack_public_path__ + "img/channelTalk.95ad37b1.png";